/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiAlbumsMutationRequest, PostApiAlbumsMutationResponse, PostApiAlbums400, PostApiAlbums401, PostApiAlbums403, PostApiAlbums404, PostApiAlbums500 } from "../../types/PostApiAlbums.ts";
import { postApiAlbumsMutationResponseSchema, postApiAlbumsMutationRequestSchema } from "../../zod/AlbumSchemas/postApiAlbumsSchema.ts";

function getPostApiAlbumsUrl() {
  const res = { method: 'POST', url: `/api/albums` as const }  
  return res
}

/**
 * @summary Метод создания альбома.
 * {@link /api/albums}
 */
export async function postApiAlbums({ data }: { data?: PostApiAlbumsMutationRequest }, config: Partial<RequestConfig<PostApiAlbumsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiAlbumsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiAlbumsMutationResponse, ResponseErrorConfig<PostApiAlbums400 | PostApiAlbums401 | PostApiAlbums403 | PostApiAlbums404 | PostApiAlbums500>, PostApiAlbumsMutationRequest>({ method : "POST", url : getPostApiAlbumsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiAlbumsMutationResponseSchema.parse(res.data)
}